// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-direction: column;
}

ng-select {
  width: 35%;
}

.second-level-menu {
  max-width: 280px;
  min-width: 280px;
}

.add-new-documents-wrapper {
  display: flex;
  align-items: center;
}

.add-new-documents {
  display: flex;
  gap: 10px;
  margin-right: 25px;
  align-items: center;
  white-space: nowrap;
}
.add-new-documents .button-text {
  display: inline;
}

.list-wrapper ul.notification-list li {
  min-height: 60px;
  color: var(--textsecondarycolor) !important;
}
.list-wrapper ul.notification-list li .icon {
  display: block !important;
}
.list-wrapper ul.notification-list li:not(.active) .fa-folder-open {
  display: none;
}
.list-wrapper ul.notification-list li.active {
  background: var(--listbackgoundhover) !important;
  color: var(--listcolor) !important;
  border-right: 3px solid #1571b9;
  border-radius: 6px;
  font-weight: 600;
}
.list-wrapper ul.notification-list li.active .fa-folder {
  display: none;
}
.list-wrapper ul.notification-list li.active .list-active,
.list-wrapper ul.notification-list li.active .lesson {
  color: var(--listcolor) !important;
}
.list-wrapper ul.notification-list li:hover {
  background: var(--listbackgoundhover) !important;
}

.elibrary-list li .is-one-quarter {
  width: 12% !important;
}

#library-card-list {
  width: 100%;
  height: 150px;
  display: none;
  overflow-y: auto;
  scrollbar-width: none;
}
#library-card-list .notification-list {
  width: 100%;
}
#library-card-list .notification-list .card {
  width: 245px;
  background: #fff;
  border-radius: 10px;
  float: left;
  margin: 5px;
}
#library-card-list .notification-list .card .card-body {
  padding: 0.2rem 0.5rem;
}
#library-card-list .notification-list .card .card-body label {
  font-size: 0.9rem;
  color: #666;
}
#library-card-list .notification-list .card .icon {
  display: none;
}
#library-card-list .notification-list .card.active {
  background: var(--primarylightColor);
  color: #fff;
}
#library-card-list .notification-list .card.active .card-body label {
  color: var(--primaryColor);
}
#library-card-list .notification-list .card.active .icon {
  display: block;
}

@media screen and (max-width: 945px) {
  ng-select {
    width: 100%;
  }
  .add-new-documents-wrapper {
    width: 100%;
    margin-top: 0.5rem;
  }
  .add-new-documents {
    margin-right: 0;
    margin-top: 0;
    gap: 5px;
    font-size: 0.85rem;
    width: 100%;
    justify-content: center;
    padding: 0.5rem 0.75rem;
    white-space: normal;
  }
  .add-new-documents .button-text {
    display: inline;
  }
  .add-new-documents i {
    font-size: 0.9rem;
  }
  .second-level-menu {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    max-width: 280px;
    min-width: 280px;
    background: #fff;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .second-level-menu.show {
    transform: translateX(0);
  }
}
@media screen and (max-width: 945px) and (min-width: 768px) and (max-width: 945px) {
  .second-level-menu {
    max-width: 320px;
    min-width: 320px;
  }
}
@media screen and (max-width: 945px) {
  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: block;
    animation: fadeIn 0.3s ease-in-out;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .mobile-sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    background: #f8f9fa;
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
  }
  .mobile-sidebar-header h4 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    flex: 1;
  }
  .mobile-sidebar-header .mobile-close-btn {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    color: #666;
    cursor: pointer;
    padding: 0.5rem;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s;
    -webkit-tap-highlight-color: transparent;
  }
  .mobile-sidebar-header .mobile-close-btn:hover, .mobile-sidebar-header .mobile-close-btn:active {
    background: #e9ecef;
  }
  .menu-options {
    padding: 0.75rem 1rem;
    gap: 0.5rem;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 5;
    border-bottom: 1px solid #f0f0f0;
  }
  .menu-options .level-left .level-item .select select,
  .menu-options .level-right .level-item .select select {
    font-size: 0.9rem;
    padding: 0.4rem 0.6rem;
    min-height: 44px;
    appearance: none;
  }
  .menu-options .level-left .level-item .button,
  .menu-options .level-right .level-item .button {
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem;
    -webkit-tap-highlight-color: transparent;
  }
  .menu-options .input-search-box {
    width: 100%;
  }
  .menu-options .input-search-box .field {
    width: 100%;
  }
  .menu-options .input-search-box .field .control {
    width: 100%;
  }
  .menu-options .input-search-box .field .control .input {
    font-size: 0.9rem;
    padding: 0.5rem 2rem 0.5rem 2.5rem;
    width: 100%;
    min-height: 44px;
  }
  .menu-options .input-search-box .field .control .icon {
    font-size: 0.85rem;
  }
  .list-wrapper {
    padding: 0.5rem 0;
    -webkit-overflow-scrolling: touch;
  }
  .list-wrapper ul.notification-list li {
    padding: 0.75rem 1rem;
    min-height: 60px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  }
  .list-wrapper ul.notification-list li .columns .column.is-one-quarter {
    width: 20% !important;
    flex: 0 0 20%;
    padding: 0 0.5rem 0 0;
  }
  .list-wrapper ul.notification-list li .columns .column.is-clearfix {
    flex: 1;
    min-width: 0;
    padding: 0 0.5rem;
  }
  .list-wrapper ul.notification-list li .columns .is-pulled-right {
    font-size: 0.85rem;
    flex-shrink: 0;
    padding-left: 0.5rem;
  }
  .list-wrapper ul.notification-list li .list-active {
    font-size: 0.95rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.4;
  }
  .list-wrapper ul.notification-list li .lesson {
    font-size: 0.8rem;
    margin-top: 0.25rem;
    display: block;
  }
  .col-auto {
    position: relative;
    width: 100%;
    max-width: 100%;
  }
  .col-auto.hide-listwrapper .second-level-menu {
    display: none;
  }
  .col {
    width: 100%;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-top: 0;
  }
  .col.ps-0 {
    padding-left: 0 !important;
  }
  .col.ps-3 {
    padding-left: 0 !important;
  }
  .empty-state {
    padding: 1rem;
    margin: 1rem;
  }
  .empty-state .box {
    padding: 1.5rem 1rem;
  }
  .empty-state .box i {
    font-size: 2.5rem;
    margin-bottom: 0.75rem;
  }
  .empty-state .box p {
    font-size: 0.95rem;
  }
  .mobile-menu-toggle {
    display: flex !important;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    margin-left: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: background 0.2s;
    -webkit-tap-highlight-color: transparent;
  }
  .mobile-menu-toggle:hover, .mobile-menu-toggle:active {
    background: #e0e0e0;
  }
  .mobile-menu-toggle i {
    font-size: 1.1rem;
  }
  .row {
    margin-left: 0;
    margin-right: 0;
    flex-wrap: wrap;
    width: 100%;
  }
  router-outlet + * {
    width: 100%;
    padding: 0.5rem;
  }
  ::ng-deep .page-title {
    flex-wrap: wrap;
    width: 100%;
  }
  ::ng-deep .page-title h3 {
    font-size: 1.1rem;
    margin: 0;
    flex: 1;
    min-width: 0;
  }
  a,
  button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
    touch-action: manipulation;
  }
  .col.ps-0 {
    padding: 0.5rem !important;
  }
  :host {
    overflow-x: hidden;
    width: 100%;
    max-width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .add-new-documents-wrapper {
    width: 100%;
    margin-top: 0.5rem;
  }
  .add-new-documents {
    font-size: 0.8rem;
    padding: 0.5rem 0.6rem;
    margin-right: 0;
    margin-top: 0;
    width: 100%;
    white-space: normal;
  }
  .add-new-documents .button-text {
    display: inline;
  }
  .add-new-documents i {
    font-size: 0.85rem;
  }
  .second-level-menu {
    max-width: 100%;
    min-width: 100%;
  }
  .mobile-sidebar-header {
    padding: 0.75rem;
  }
  .mobile-sidebar-header h4 {
    font-size: 1rem;
  }
  .menu-options {
    padding: 0.5rem 0.75rem;
  }
  .menu-options .level-left .level-item .select select,
  .menu-options .level-right .level-item .select select {
    font-size: 0.85rem;
    padding: 0.35rem 0.5rem;
  }
  .menu-options .level-left .level-item .button,
  .menu-options .level-right .level-item .button {
    min-width: 40px;
    min-height: 40px;
    padding: 0.4rem;
  }
  .list-wrapper ul.notification-list li {
    padding: 0.6rem 0.75rem;
    min-height: 55px;
  }
  .list-wrapper ul.notification-list li .columns .column.is-one-quarter {
    width: 18% !important;
    flex: 0 0 18%;
    padding: 0 0.4rem 0 0;
  }
  .list-wrapper ul.notification-list li .columns .column.is-clearfix {
    padding: 0 0.4rem;
  }
  .list-wrapper ul.notification-list li .columns .is-pulled-right {
    font-size: 0.8rem;
    padding-left: 0.4rem;
  }
  .list-wrapper ul.notification-list li .list-active {
    font-size: 0.9rem;
  }
  .list-wrapper ul.notification-list li .lesson {
    font-size: 0.75rem;
  }
  .empty-state {
    padding: 0.75rem;
    margin: 0.5rem;
  }
  .empty-state .box {
    padding: 1rem 0.75rem;
  }
  .empty-state .box i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }
  .empty-state .box p {
    font-size: 0.9rem;
  }
  .mobile-menu-toggle {
    min-width: 40px;
    min-height: 40px;
    margin-left: 0.25rem;
  }
  .mobile-menu-toggle i {
    font-size: 1rem;
  }
  ::ng-deep .page-title {
    padding: 8px 10px;
  }
  ::ng-deep .page-title h3 {
    font-size: 1rem;
  }
  .col.ps-0 {
    padding: 0.25rem !important;
  }
}
.notification-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notification-list li.chat-list {
  position: relative;
  padding: 0.6rem 0.8rem;
  border-radius: 6px;
  transition: background 0.2s ease;
}
.notification-list li.chat-list:hover {
  background-color: #f9f9f9;
}
.notification-list li.chat-list:hover .delete-icon {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.notification-list li.chat-list .delete-icon {
  position: absolute;
  right: 0px;
  top: 25%;
  transform: translateY(0);
  opacity: 0;
  visibility: visible;
  transition: all 0.2s ease;
  cursor: pointer;
}
.notification-list li.chat-list .delete-icon i {
  color: #d9534f !important;
  font-size: 14px;
}
.notification-list li.chat-list .delete-icon:hover i {
  color: #c9302c !important;
}
.notification-list li.chat-list .user-count {
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.9rem;
  color: #666;
}

@media screen and (min-width: 946px) and (max-width: 1024px) {
  .second-level-menu {
    max-width: 260px;
    min-width: 260px;
  }
  .add-new-documents-wrapper {
    flex: 0 0 auto;
  }
  .add-new-documents {
    margin-right: 15px;
    font-size: 0.9rem;
    white-space: nowrap;
  }
  .col.ps-3 {
    padding-left: 1rem !important;
  }
}
@media screen and (min-width: 946px) {
  .mobile-menu-toggle {
    display: none !important;
  }
  .sidebar-overlay {
    display: none !important;
  }
  .mobile-sidebar-header {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/elibraryandcourse/e-library/e-library.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;AACJ;;AAKI;EACE,gBAAA;EACA,2CAAA;AAFN;AAIM;EACE,yBAAA;AAFR;AAQM;EACE,aAAA;AANR;AAUI;EACE,gDAAA;EACA,kCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,gBAAA;AATN;AAWM;EACE,aAAA;AATR;AAYM;;EAEE,kCAAA;AAVR;AAeI;EACE,gDAAA;AAbN;;AAmBE;EACE,qBAAA;AAhBJ;;AAoBA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAjBF;AAmBE;EACE,WAAA;AAjBJ;AAmBI;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AAjBN;AAmBM;EACE,sBAAA;AAjBR;AAmBQ;EACE,iBAAA;EACA,WAAA;AAjBV;AAqBM;EACE,aAAA;AAnBR;AAsBM;EACE,oCAAA;EACA,WAAA;AApBR;AAuBU;EACE,0BAAA;AArBZ;AAyBQ;EACE,cAAA;AAvBV;;AAiCA;EACE;IACE,WAAA;EA9BF;EAiCA;IACE,WAAA;IACA,kBAAA;EA/BF;EAkCA;IACE,eAAA;IACA,aAAA;IACA,QAAA;IACA,kBAAA;IACA,WAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;EAhCF;EAkCE;IACE,eAAA;EAhCJ;EAmCE;IACE,iBAAA;EAjCJ;EAqCA;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,aAAA;IACA,aAAA;IACA,4BAAA;IACA,sCAAA;IACA,gBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yCAAA;IACA,gBAAA;IACA,iCAAA;EAnCF;EAqCE;IACE,wBAAA;EAnCJ;AACF;AAuCE;EACE;IACE,gBAAA;IACA,gBAAA;EArCJ;AACF;AAjBA;EAyDE;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,8BAAA;IACA,YAAA;IACA,cAAA;IACA,kCAAA;EArCF;EAwCA;IACE;MACE,UAAA;IAtCF;IAyCA;MACE,UAAA;IAvCF;EACF;EA0CA;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,aAAA;IACA,gCAAA;IACA,mBAAA;IACA,gBAAA;IACA,MAAA;IACA,WAAA;IACA,gBAAA;EAxCF;EA0CE;IACE,SAAA;IACA,iBAAA;IACA,gBAAA;IACA,OAAA;EAxCJ;EA2CE;IACE,uBAAA;IACA,YAAA;IACA,iBAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,2BAAA;IACA,wCAAA;EAzCJ;EA2CI;IAEE,mBAAA;EA1CN;EA+CA;IACE,qBAAA;IACA,WAAA;IACA,gBAAA;IACA,MAAA;IACA,gBAAA;IACA,UAAA;IACA,gCAAA;EA7CF;EAmDQ;;IACE,iBAAA;IACA,sBAAA;IACA,gBAAA;IAEA,gBAAA;EAhDV;EAoDM;;IACE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,wCAAA;EAjDR;EAsDE;IACE,WAAA;EApDJ;EAsDI;IACE,WAAA;EApDN;EAsDM;IACE,WAAA;EApDR;EAsDQ;IACE,iBAAA;IACA,kCAAA;IACA,WAAA;IACA,gBAAA;EApDV;EAuDQ;IACE,kBAAA;EArDV;EA4DA;IACE,iBAAA;IACA,iCAAA;EA1DF;EA6DI;IACE,qBAAA;IACA,gBAAA;IACA,+CAAA;EA3DN;EA+DU;IACE,qBAAA;IACA,aAAA;IACA,qBAAA;EA7DZ;EAgEU;IACE,OAAA;IACA,YAAA;IACA,iBAAA;EA9DZ;EAkEQ;IACE,kBAAA;IACA,cAAA;IACA,oBAAA;EAhEV;EAoEM;IACE,kBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;EAlER;EAqEM;IACE,iBAAA;IACA,mBAAA;IACA,cAAA;EAnER;EAyEA;IACE,kBAAA;IACA,WAAA;IACA,eAAA;EAvEF;EA0EI;IACE,aAAA;EAxEN;EA6EA;IACE,WAAA;IACA,0BAAA;IACA,2BAAA;IACA,aAAA;EA3EF;EA6EE;IACE,0BAAA;EA3EJ;EA8EE;IACE,0BAAA;EA5EJ;EAgFA;IACE,aAAA;IACA,YAAA;EA9EF;EAgFE;IACE,oBAAA;EA9EJ;EAgFI;IACE,iBAAA;IACA,sBAAA;EA9EN;EAiFI;IACE,kBAAA;EA/EN;EAoFA;IACE,wBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,2BAAA;IACA,wCAAA;EAlFF;EAoFE;IAEE,mBAAA;EAnFJ;EAsFE;IACE,iBAAA;EApFJ;EAwFA;IACE,cAAA;IACA,eAAA;IACA,eAAA;IACA,WAAA;EAtFF;EA2FE;IACE,WAAA;IACA,eAAA;EAzFJ;EA8FA;IACE,eAAA;IACA,WAAA;EA5FF;EA8FE;IACE,iBAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;EA5FJ;EAiGA;;IAEE,+CAAA;IACA,0BAAA;EA/FF;EAmGA;IACE,0BAAA;EAjGF;EAqGA;IACE,kBAAA;IACA,WAAA;IACA,eAAA;EAnGF;AACF;AAuGA;EACE;IACE,WAAA;IACA,kBAAA;EArGF;EAwGA;IACE,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,aAAA;IACA,WAAA;IACA,mBAAA;EAtGF;EAwGE;IACE,eAAA;EAtGJ;EAyGE;IACE,kBAAA;EAvGJ;EA2GA;IACE,eAAA;IACA,eAAA;EAzGF;EA4GA;IACE,gBAAA;EA1GF;EA4GE;IACE,eAAA;EA1GJ;EA8GA;IACE,uBAAA;EA5GF;EAkHQ;;IACE,kBAAA;IACA,uBAAA;EA/GV;EAmHM;;IACE,eAAA;IACA,gBAAA;IACA,eAAA;EAhHR;EAwHI;IACE,uBAAA;IACA,gBAAA;EAtHN;EA0HU;IACE,qBAAA;IACA,aAAA;IACA,qBAAA;EAxHZ;EA2HU;IACE,iBAAA;EAzHZ;EA6HQ;IACE,iBAAA;IACA,oBAAA;EA3HV;EA+HM;IACE,iBAAA;EA7HR;EAgIM;IACE,kBAAA;EA9HR;EAoIA;IACE,gBAAA;IACA,cAAA;EAlIF;EAoIE;IACE,qBAAA;EAlIJ;EAoII;IACE,eAAA;IACA,qBAAA;EAlIN;EAqII;IACE,iBAAA;EAnIN;EAwIA;IACE,eAAA;IACA,gBAAA;IACA,oBAAA;EAtIF;EAwIE;IACE,eAAA;EAtIJ;EA0IA;IACE,iBAAA;EAxIF;EA0IE;IACE,eAAA;EAxIJ;EA6IA;IACE,2BAAA;EA3IF;AACF;AA8IA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AA5IF;AA8IE;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;AA5IJ;AA8II;EACE,yBAAA;AA5IN;AA8IM;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AA5IR;AAgJI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,wBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA9IN;AAgJM;EACE,yBAAA;EACA,eAAA;AA9IR;AAiJM;EACE,yBAAA;AA/IR;AAmJI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;EACA,WAAA;AAjJN;;AAyJA;EACE;IACE,gBAAA;IACA,gBAAA;EAtJF;EAyJA;IACE,cAAA;EAvJF;EA0JA;IACE,kBAAA;IACA,iBAAA;IACA,mBAAA;EAxJF;EA4JE;IACE,6BAAA;EA1JJ;AACF;AA+JA;EACE;IACE,wBAAA;EA7JF;EAgKA;IACE,wBAAA;EA9JF;EAiKA;IACE,wBAAA;EA/JF;AACF","sourcesContent":[":host {\n  flex-direction: column;\n}\n\nng-select {\n  width: 35%;\n}\n\n.second-level-menu {\n  max-width: 280px;\n  min-width: 280px;\n}\n\n.add-new-documents-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.add-new-documents {\n  display: flex;\n  gap: 10px;\n  margin-right: 25px;\n  align-items: center;\n  white-space: nowrap;\n\n  .button-text {\n    display: inline;\n  }\n}\n\n.list-wrapper {\n  ul.notification-list {\n    li {\n      min-height: 60px;\n      color: var(--textsecondarycolor) !important;\n\n      .icon{\n        display: block !important;\n      }\n\n    }\n\n    li:not(.active) {\n      .fa-folder-open {\n        display: none;\n      }\n    }\n\n    li.active {\n      background: var(--listbackgoundhover) !important;\n      color: var(--listcolor) !important;\n      // border-top: 1px solid #4bf768;\n      border-right: 3px solid #1571b9;\n      border-radius: 6px;\n      font-weight: 600;\n\n      .fa-folder {\n        display: none;\n      }\n\n      .list-active,\n      .lesson {\n        color: var(--listcolor) !important;\n      }\n\n    }\n\n    li:hover {\n      background: var(--listbackgoundhover) !important;\n    }\n  }\n}\n\n.elibrary-list {\n  li .is-one-quarter {\n    width: 12% !important;\n  }\n}\n\n#library-card-list {\n  width: 100%;\n  height: 150px;\n  display: none;\n  overflow-y: auto;\n  scrollbar-width: none;\n\n  .notification-list {\n    width: 100%;\n\n    .card {\n      width: 245px;\n      background: #fff;\n      border-radius: 10px;\n      float: left;\n      margin: 5px;\n\n      .card-body {\n        padding: .2rem .5rem;\n\n        label {\n          font-size: .9rem;\n          color: #666;\n        }\n      }\n\n      .icon {\n        display: none;\n      }\n\n      &.active {\n        background: var(--primarylightColor);\n        color: #fff;\n\n        .card-body {\n          label {\n            color: var(--primaryColor);\n          }\n        }\n\n        .icon {\n          display: block;\n        }\n      }\n    }\n  }\n\n\n}\n\n// Mobile responsive styles (up to 945px)\n@media screen and (max-width: 945px) {\n  ng-select {\n    width: 100%;\n  }\n\n  .add-new-documents-wrapper {\n    width: 100%;\n    margin-top: 0.5rem;\n  }\n\n  .add-new-documents {\n    margin-right: 0;\n    margin-top: 0;\n    gap: 5px;\n    font-size: 0.85rem;\n    width: 100%;\n    justify-content: center;\n    padding: 0.5rem 0.75rem;\n    white-space: normal;\n\n    .button-text {\n      display: inline;\n    }\n\n    i {\n      font-size: 0.9rem;\n    }\n  }\n\n  .second-level-menu {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 1000;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease-in-out;\n    max-width: 280px;\n    min-width: 280px;\n    background: #fff;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n\n    &.show {\n      transform: translateX(0);\n    }\n  }\n\n  // Adjust sidebar width for larger mobile screens (768px - 945px)\n  @media screen and (min-width: 768px) and (max-width: 945px) {\n    .second-level-menu {\n      max-width: 320px;\n      min-width: 320px;\n    }\n  }\n\n  .sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n    display: block;\n    animation: fadeIn 0.3s ease-in-out;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  .mobile-sidebar-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    border-bottom: 1px solid #e0e0e0;\n    background: #f8f9fa;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background: #fff;\n\n    h4 {\n      margin: 0;\n      font-size: 1.1rem;\n      font-weight: 600;\n      flex: 1;\n    }\n\n    .mobile-close-btn {\n      background: transparent;\n      border: none;\n      font-size: 1.2rem;\n      color: #666;\n      cursor: pointer;\n      padding: 0.5rem;\n      min-width: 44px;\n      min-height: 44px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 4px;\n      transition: background 0.2s;\n      -webkit-tap-highlight-color: transparent;\n\n      &:hover,\n      &:active {\n        background: #e9ecef;\n      }\n    }\n  }\n\n  .menu-options {\n    padding: 0.75rem 1rem;\n    gap: 0.5rem;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 5;\n    border-bottom: 1px solid #f0f0f0;\n\n    .level-left,\n    .level-right {\n      .level-item {\n        .select {\n          select {\n            font-size: 0.9rem;\n            padding: 0.4rem 0.6rem;\n            min-height: 44px;\n            -webkit-appearance: none;\n            appearance: none;\n          }\n        }\n\n        .button {\n          min-width: 44px;\n          min-height: 44px;\n          padding: 0.5rem;\n          -webkit-tap-highlight-color: transparent;\n        }\n      }\n    }\n\n    .input-search-box {\n      width: 100%;\n\n      .field {\n        width: 100%;\n\n        .control {\n          width: 100%;\n\n          .input {\n            font-size: 0.9rem;\n            padding: 0.5rem 2rem 0.5rem 2.5rem;\n            width: 100%;\n            min-height: 44px;\n          }\n\n          .icon {\n            font-size: 0.85rem;\n          }\n        }\n      }\n    }\n  }\n\n  .list-wrapper {\n    padding: 0.5rem 0;\n    -webkit-overflow-scrolling: touch;\n\n    ul.notification-list {\n      li {\n        padding: 0.75rem 1rem;\n        min-height: 60px;\n        -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);\n\n        .columns {\n          .column {\n            &.is-one-quarter {\n              width: 20% !important;\n              flex: 0 0 20%;\n              padding: 0 0.5rem 0 0;\n            }\n\n            &.is-clearfix {\n              flex: 1;\n              min-width: 0;\n              padding: 0 0.5rem;\n            }\n          }\n\n          .is-pulled-right {\n            font-size: 0.85rem;\n            flex-shrink: 0;\n            padding-left: 0.5rem;\n          }\n        }\n\n        .list-active {\n          font-size: 0.95rem;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          line-height: 1.4;\n        }\n\n        .lesson {\n          font-size: 0.8rem;\n          margin-top: 0.25rem;\n          display: block;\n        }\n      }\n    }\n  }\n\n  .col-auto {\n    position: relative;\n    width: 100%;\n    max-width: 100%;\n\n    &.hide-listwrapper {\n      .second-level-menu {\n        display: none;\n      }\n    }\n  }\n\n  .col {\n    width: 100%;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    margin-top: 0;\n\n    &.ps-0 {\n      padding-left: 0 !important;\n    }\n\n    &.ps-3 {\n      padding-left: 0 !important;\n    }\n  }\n\n  .empty-state {\n    padding: 1rem;\n    margin: 1rem;\n\n    .box {\n      padding: 1.5rem 1rem;\n\n      i {\n        font-size: 2.5rem;\n        margin-bottom: 0.75rem;\n      }\n\n      p {\n        font-size: 0.95rem;\n      }\n    }\n  }\n\n  .mobile-menu-toggle {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    min-width: 44px;\n    min-height: 44px;\n    margin-left: 0.5rem;\n    background: #f0f0f0;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    transition: background 0.2s;\n    -webkit-tap-highlight-color: transparent;\n\n    &:hover,\n    &:active {\n      background: #e0e0e0;\n    }\n\n    i {\n      font-size: 1.1rem;\n    }\n  }\n\n  .row {\n    margin-left: 0;\n    margin-right: 0;\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  // Ensure proper spacing for router outlet content\n  router-outlet {\n    +* {\n      width: 100%;\n      padding: 0.5rem;\n    }\n  }\n\n  // Page title adjustments\n  ::ng-deep .page-title {\n    flex-wrap: wrap;\n    width: 100%;\n\n    h3 {\n      font-size: 1.1rem;\n      margin: 0;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  // Improve touch targets\n  a,\n  button {\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);\n    touch-action: manipulation;\n  }\n\n  // Better spacing for content area\n  .col.ps-0 {\n    padding: 0.5rem !important;\n  }\n\n  // Prevent content overflow\n  :host {\n    overflow-x: hidden;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n// Small mobile devices (phones in portrait)\n@media screen and (max-width: 480px) {\n  .add-new-documents-wrapper {\n    width: 100%;\n    margin-top: 0.5rem;\n  }\n\n  .add-new-documents {\n    font-size: 0.8rem;\n    padding: 0.5rem 0.6rem;\n    margin-right: 0;\n    margin-top: 0;\n    width: 100%;\n    white-space: normal;\n\n    .button-text {\n      display: inline;\n    }\n\n    i {\n      font-size: 0.85rem;\n    }\n  }\n\n  .second-level-menu {\n    max-width: 100%;\n    min-width: 100%;\n  }\n\n  .mobile-sidebar-header {\n    padding: 0.75rem;\n\n    h4 {\n      font-size: 1rem;\n    }\n  }\n\n  .menu-options {\n    padding: 0.5rem 0.75rem;\n\n    .level-left,\n    .level-right {\n      .level-item {\n        .select {\n          select {\n            font-size: 0.85rem;\n            padding: 0.35rem 0.5rem;\n          }\n        }\n\n        .button {\n          min-width: 40px;\n          min-height: 40px;\n          padding: 0.4rem;\n        }\n      }\n    }\n  }\n\n  .list-wrapper {\n    ul.notification-list {\n      li {\n        padding: 0.6rem 0.75rem;\n        min-height: 55px;\n\n        .columns {\n          .column {\n            &.is-one-quarter {\n              width: 18% !important;\n              flex: 0 0 18%;\n              padding: 0 0.4rem 0 0;\n            }\n\n            &.is-clearfix {\n              padding: 0 0.4rem;\n            }\n          }\n\n          .is-pulled-right {\n            font-size: 0.8rem;\n            padding-left: 0.4rem;\n          }\n        }\n\n        .list-active {\n          font-size: 0.9rem;\n        }\n\n        .lesson {\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n  .empty-state {\n    padding: 0.75rem;\n    margin: 0.5rem;\n\n    .box {\n      padding: 1rem 0.75rem;\n\n      i {\n        font-size: 2rem;\n        margin-bottom: 0.5rem;\n      }\n\n      p {\n        font-size: 0.9rem;\n      }\n    }\n  }\n\n  .mobile-menu-toggle {\n    min-width: 40px;\n    min-height: 40px;\n    margin-left: 0.25rem;\n\n    i {\n      font-size: 1rem;\n    }\n  }\n\n  ::ng-deep .page-title {\n    padding: 8px 10px;\n\n    h3 {\n      font-size: 1rem;\n    }\n  }\n\n  // Better spacing for very small screens\n  .col.ps-0 {\n    padding: 0.25rem !important;\n  }\n}\n\n.notification-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  li.chat-list {\n    position: relative;\n    padding: 0.6rem 0.8rem;\n    border-radius: 6px;\n    transition: background 0.2s ease;\n\n    &:hover {\n      background-color: #f9f9f9;\n\n      .delete-icon {\n        opacity: 1;\n        visibility: visible;\n        transform: translateY(0);\n      }\n    }\n\n    .delete-icon {\n      position: absolute;\n      right: 0px;\n      top: 25%;\n      transform: translateY(0);\n      opacity: 0;\n      visibility: visible;\n      transition: all 0.2s ease;\n      cursor: pointer;\n\n      i {\n        color: #d9534f !important;\n        font-size: 14px;\n      }\n\n      &:hover i {\n        color: #c9302c !important;\n      }\n    }\n\n    .user-count {\n      position: absolute;\n      right: 40px;\n      top: 50%;\n      transform: translateY(-50%);\n      font-size: 0.9rem;\n      color: #666;\n    }\n  }\n}\n\n\n\n// Tablet responsive styles (946px to 1024px)\n@media screen and (min-width: 946px) and (max-width: 1024px) {\n  .second-level-menu {\n    max-width: 260px;\n    min-width: 260px;\n  }\n\n  .add-new-documents-wrapper {\n    flex: 0 0 auto;\n  }\n\n  .add-new-documents {\n    margin-right: 15px;\n    font-size: 0.9rem;\n    white-space: nowrap;\n  }\n\n  .col {\n    &.ps-3 {\n      padding-left: 1rem !important;\n    }\n  }\n}\n\n// Hide mobile menu toggle on desktop (946px and above)\n@media screen and (min-width: 946px) {\n  .mobile-menu-toggle {\n    display: none !important;\n  }\n\n  .sidebar-overlay {\n    display: none !important;\n  }\n\n  .mobile-sidebar-header {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
